import { createTheme } from '@mui/material/styles';
import wdsCompatibilityFigmaExport from './figma-exports/compatibility-theme/theme.json';
/**
 * GENERATED THEME
 *
 * The theme contained within wdsCompatibilityFigmaExport has been generated automatically
 * and shouldn't be edited. If you think the theme here isn't matching the design,
 * contact the Design Team.
 *
 * To update the theme, see "Updating the theme" in the readme.
 */
export const compatibilityTheme = createTheme(Object.assign(Object.assign({}, wdsCompatibilityFigmaExport), { cssVariables: {
        colorSchemeSelector: 'data-mui-color-scheme',
    }, components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                    letterSpacing: 0,
                    textTransform: 'none',
                },
            },
        },
    } }));
//# sourceMappingURL=compatibilityTheme.js.map